export const statusResponse = {
  failed: 'gagal',
}
